import { RouteRecordRaw } from "vue-router";
import { PATH } from "@/core/constants/path";

// Route modules define lazy-loaded view components; this file only wires paths and metadata.
import DashboardRoutes from "@/modules/Dashboard/route";
import AgentRoutes from "@/modules/Agent/route";
import OrganizationRoutes from "@/modules/Organization/route";
import SOARoutes from "@/modules/SOA/route";
import SabreSegmentRoutes from "@/modules/SabreSegment/route";
import MyBookingsRoutes from "@/modules/MyBookings/route";
import MyIssuanceRoutes from "@/modules/MyIssuances/route";
import PaymentRoutes from "@/modules/Payments/route";
import CreditLimitManagementRoutes from "@/modules/CreditLimitManagement/route";
import NewsRoutes from "@/modules/News/route";
import fareManagementRoutes from "@/modules/FareManagement/route";
import PricingRoutes from "@/modules/Pricing/route";
import quotationManagement from "@/modules/ManageQuotations/route";
import UserProfileRoutes from "@/modules/Profile/route";
import SalesRoutes from "@/modules/Sales/route";
import Error403Route from "@/modules/403/route";
import Error404Route from "@/modules/404/route";
import DealsAndPromos from "@/modules/Deals/route";
import VisaVerification from "@/modules/VisaVerification/route";
import SnapShots from "@/modules/Snapshots/route";
import ChurningRoutes from "@/modules/Churning/route";
import GroupsRoutes from "@/modules/Groups/route";
import EmployeeGradeRoutes from "@/modules/EmployeeGrade/route";
import CostCenterRoutes from "@/modules/CostCenter/route";
import {
  MyPoliciesRoutes,
  CorporatePolicyRoutes,
} from "@/modules/CorporatePolicy/route";
import DepartmentRoutes from "@/modules/Department/route";
import ApprovalSystemRoutes from "@/modules/ApprovalSystem/route";
import ApprovalRequestsRoutes, {
  ApprovalDelegationRoutes,
  AssignedApprovalsRoutes,
  MyApprovalsRoutes,
} from "@/modules/ApprovalRequests/route";

const HomeRoutes: Array<RouteRecordRaw> = [
  {
    path: PATH.DASHBOARD,
    children: DashboardRoutes,
  },
  {
    path: PATH.AGENT_MANAGEMENT,
    children: AgentRoutes,
  },
  {
    path: PATH.ORGANIZATION,
    children: OrganizationRoutes,
  },
  {
    path: PATH.EMPLOYEE_GRADE,
    children: EmployeeGradeRoutes,
  },
  {
    path: PATH.COST_CENTER,
    children: CostCenterRoutes,
  },
  {
    path: PATH.CORPORATE_POLICY,
    children: CorporatePolicyRoutes,
  },
  {
    path: PATH.MY_POLICIES,
    children: MyPoliciesRoutes,
  },
  {
    path: PATH.DEPARTMENT,
    children: DepartmentRoutes,
  },
  {
    path: PATH.APPROVAL_SYSTEM,
    children: ApprovalSystemRoutes,
  },
  {
    path: PATH.APPROVAL_REQUESTS,
    children: ApprovalRequestsRoutes,
  },
  {
    path: PATH.MY_APPROVALS,
    children: MyApprovalsRoutes,
  },
  {
    path: PATH.ASSIGNED_APPROVALS,
    children: AssignedApprovalsRoutes,
  },
  {
    path: PATH.APPROVAL_DELEGATION,
    children: ApprovalDelegationRoutes,
  },
  {
    path: PATH.SOA,
    children: SOARoutes,
  },
  {
    path: PATH.MY_BOOKINGS,
    children: MyBookingsRoutes,
  },
  {
    path: PATH.PAYMENTS,
    children: PaymentRoutes,
  },
  {
    path: PATH.USER_PROFILE,
    children: UserProfileRoutes,
  },
  {
    path: PATH.CREDIT_LIMIT_MANAGEMENT,
    children: CreditLimitManagementRoutes,
  },
  {
    path: PATH.SABRE_SEGMENT,
    children: SabreSegmentRoutes,
  },
  {
    path: PATH.NEWS,
    children: NewsRoutes,
  },
  {
    path: PATH.FARE_MANAGEMENT,
    children: fareManagementRoutes,
  },
  {
    path: PATH.PRICING,
    children: PricingRoutes,
  },
  {
    path: PATH.MANAGE_QUOTATIONS,
    children: quotationManagement,
  },
  {
    path: PATH.SALES,
    children: SalesRoutes,
  },
  {
    path: PATH.Error_403,
    children: Error403Route,
  },
  {
    path: PATH.Error_404,
    children: Error404Route,
  },
  {
    path: PATH.DEALS_AND_PROMOS,
    children: DealsAndPromos,
  },
  {
    path: PATH.VISA_VERIFICATION,
    children: VisaVerification,
  },
  {
    path: PATH.SNAPSHOTS,
    children: SnapShots,
  },
  {
    path: PATH.MY_ISSUANCE,
    children: MyIssuanceRoutes,
  },
  {
    path: PATH.CHURNING,
    children: ChurningRoutes,
  },
  {
    path: PATH.GROUPS,
    children: GroupsRoutes,
  },
];

export default HomeRoutes;
